<template>
    <v-container fluid class="az-container configuracao-incisos-cadastro-container" style="margin: 0 !important; border-radius: 10px !important;">
        <div class="pa-md-5 px-3 pt-3">
            <a href="" @click.prevent="onVoltar" class="back-link">« Voltar para listagem</a>
        </div>

        <v-layout class="pa-md-5 pa-3" row>
            <v-flex xs12>
                <v-card class="px-3 pt-3 pb-5 px-md-5" color="white" style="border-radius: 10px !important;">
                    <div class="separator-primary separator-top mb-5"></div>

            <v-form ref="form" v-model="formularioValido">
                <v-layout row wrap>
                    <v-flex xs12 md4 class="px-2">
                        <div class="field-group">
                            <label class="field-label">Amparo Legal <span style="color: red">*</span></label>
                            <v-select
                                v-model="formulario.amparo"
                                :items="listaAmparos"
                                item-text="amparo"
                                item-value="amparo"
                                placeholder="Selecione"
                                :loading="carregandoAmparos"
                                :rules="[regras.obrigatorio]"
                                @change="onAmparoChange"
                                solo
                                flat
                                hide-details="auto"
                                class="underline-field"
                            ></v-select>
                        </div>
                    </v-flex>

                    <v-flex xs12 md4 class="px-2">
                        <div class="field-group">
                            <label class="field-label">Artigo <span style="color: red">*</span></label>
                            <v-select
                                v-model="formulario.artigo"
                                :items="listaArtigos"
                                item-text="artigo"
                                item-value="artigo"
                                placeholder="Selecione"
                                :loading="carregandoArtigos"
                                :disabled="!formulario.amparo"
                                :rules="[regras.obrigatorio]"
                                @change="onArtigoChange"
                                solo
                                flat
                                hide-details="auto"
                                class="underline-field"
                            ></v-select>
                        </div>
                    </v-flex>

                    <v-flex xs12 md4 class="px-2">
                        <div class="field-group">
                            <label class="field-label">Inciso <span style="color: red">*</span></label>
                            <v-select
                                v-model="formulario.inciso"
                                :items="listaIncisos"
                                item-text="inciso"
                                item-value="inciso"
                                placeholder="Selecione"
                                :loading="carregandoIncisos"
                                :disabled="!formulario.artigo"
                                :rules="[regras.obrigatorio]"
                                solo
                                flat
                                hide-details="auto"
                                class="underline-field"
                            ></v-select>
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout row wrap align-center class="mt-3">
                    <v-flex xs12 md4 class="px-2">
                        <div class="field-group">
                            <label class="field-label">Prazo <span style="color: red">*</span></label>
                            <v-text-field
                                v-model="formulario.prazo"
                                placeholder="informe"
                                :rules="[regras.obrigatorio, regras.prazoInteiroPositivo]"
                                @keypress="apenasNumeros"
                                solo
                                flat
                                hide-details="auto"
                                class="underline-field"
                            ></v-text-field>
                        </div>
                    </v-flex>

                    <v-flex xs12 md4 class="px-2">
                        <div class="field-group">
                          <label class="field-label">Publicação <span style="color: red">*</span></label>
                            <v-radio-group
                                v-model="formulario.publicacao"
                                row
                                hide-details
                                class="mt-2"
                                :rules="[regras.obrigatorio]"
                            >
                                <v-radio :value="true" label="Sim" color="primary"></v-radio>
                                <v-radio :value="false" label="Não" color="primary"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-flex>

                    <v-flex xs12 md4 class="px-2">
                        <div class="field-group">
                            <label class="field-label">Dias Mínimo <span style="color: red">*</span></label>
                            <v-radio-group
                                v-model="formulario.prazoMinimo"
                                row
                                hide-details
                                class="mt-2"
                                :rules="[regras.obrigatorio]"
                            >
                                <v-radio :value="true" label="Sim" color="primary"></v-radio>
                                <v-radio :value="false" label="Não" color="primary"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-flex>
                </v-layout>
                <div style="min-height: 100px;"></div>
                <v-divider class="my-4"></v-divider>
                <v-layout row wrap justify-end class="mt-3">
                    <v-btn
                        flat
                        @click="onCancelar"
                        class="text-none"
                        style="color: #757575;"
                        :disabled="salvando"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        depressed
                        @click="onSalvar"
                        class="ml-2"
                        :disabled="!formularioValido || salvando"
                        :loading="salvando"
                    >
                        Salvar
                    </v-btn>
                </v-layout>
            </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { actionTypes } from '@/core/constants'
import alertMixin from '@/views/mixins/alert'

export default {
    name: 'ConfiguracaoIncisosCadastro',
    mixins: [alertMixin],
    data: () => ({
        formularioValido: false,
        salvando: false,
        carregandoAmparos: false,
        carregandoArtigos: false,
        carregandoIncisos: false,
        formulario: {
            amparo: null,
            artigo: null,
            inciso: null,
            prazo: null,
            publicacao: true,
            prazoMinimo: true
        },
        listaAmparos: [],
        listaArtigos: [],
        listaIncisos: [],
        regras: {
            obrigatorio: v => (v !== null && v !== undefined && v !== '') || 'Campo obrigatório',
            prazoInteiroPositivo: v => {
                if (!v || v === '') return 'Campo obrigatório'
                const numero = parseInt(v, 10)
                if (isNaN(numero)) return 'Informe apenas números'
                if (!Number.isInteger(numero)) return 'Informe um número inteiro'
                if (numero <= 0) return 'O prazo deve ser maior que zero'
                return true
            }
        }
    }),
    created() {
        this.buscarAmparos()
    },
    methods: {
        apenasNumeros(event) {
            const tecla = event.key
            if (!/^\d$/.test(tecla)) {
                event.preventDefault()
            }
        },
        onCancelar() {
            this.onVoltar()
        },
        normalizar(resposta, campo) {
            const lista = Array.isArray(resposta) ? resposta : []
            const valoresUnicos = Array.from(new Set(lista.map(i => i && i[campo]).filter(v => v)))
            return valoresUnicos.sort().map(v => ({ [campo]: v }))
        },
        async buscarAmparos() {
            this.carregandoAmparos = true
            try {
                const resposta = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AMPAROS_LEGAIS_HIERARQUICO, {})
                this.listaAmparos = this.normalizar(resposta, 'amparo')
            } catch (e) {
                this.mostrarNotificacaoErro('Erro ao buscar amparos legais')
                this.listaAmparos = []
            } finally {
                this.carregandoAmparos = false
            }
        },
        async onAmparoChange() {
            this.formulario.artigo = null
            this.formulario.inciso = null
            this.listaArtigos = []
            this.listaIncisos = []

            if (this.formulario.amparo) {
                await this.buscarArtigos()
            }
        },
        async buscarArtigos() {
            this.carregandoArtigos = true
            try {
                const resposta = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AMPAROS_LEGAIS_HIERARQUICO, {
                    amparo: this.formulario.amparo
                })
                this.listaArtigos = this.normalizar(resposta, 'artigo')
            } catch (e) {
                this.mostrarNotificacaoErro('Erro ao buscar artigos')
                this.listaArtigos = []
            } finally {
                this.carregandoArtigos = false
            }
        },
        async onArtigoChange() {
            this.formulario.inciso = null
            this.listaIncisos = []

            if (this.formulario.artigo) {
                await this.buscarIncisos()
            }
        },
        async buscarIncisos() {
            this.carregandoIncisos = true
            try {
                const resposta = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AMPAROS_LEGAIS_HIERARQUICO, {
                    amparo: this.formulario.amparo,
                    artigo: this.formulario.artigo
                })
                this.listaIncisos = this.normalizar(resposta, 'inciso')
            } catch (e) {
                this.mostrarNotificacaoErro('Erro ao buscar incisos')
                this.listaIncisos = []
            } finally {
                this.carregandoIncisos = false
            }
        },
        async onSalvar() {
            if (!this.$refs.form.validate()) {
                return
            }

            this.salvando = true
            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.CADASTRAR_CONFIGURACAO_PRAZO_INCISO, {
                    amparo: this.formulario.amparo,
                    artigo: this.formulario.artigo,
                    inciso: this.formulario.inciso,
                    prazo: this.formulario.prazo,
                    publicacao: this.formulario.publicacao,
                    prazoMinimo: this.formulario.prazoMinimo
                })
                this.mostrarNotificacaoSucessoDefault()
                this.onVoltar()
            } catch (e) {
                this.mostrarNotificacaoErro(e.message || 'Erro ao salvar configuração')
            } finally {
                this.salvando = false
            }
        },
        onVoltar() {
            if (this.$router && typeof this.$router.push === 'function') {
                this.$router.push({ name: 'ConfiguracaoIncisos' })
            } else {
                this.$emit('voltar')
            }
        }
    }
}
</script>

<style scoped>
.configuracao-incisos-cadastro-container {
    background-color: #f5f5f5;
    min-height: 100vh;
}

.separator-primary {
    height: 8px;
    background-color: #1976D2;
}

.separator-top {
    margin-top: -15px;
    margin-left: -16px;
    margin-right: -12px;
}

@media (min-width: 960px) {
    .separator-top {
        margin-left: -16px;
        margin-right: -16px;
    }
}

.back-link {
    text-decoration: none;
    color: #1976d2;
    font-size: 14px;
    font-weight: 300;
}

.back-link:hover {
    text-decoration: underline;
}

.field-group {
    margin-bottom: 24px;
}

.field-label {
    font-size: 12px;
    display: block;
    margin-bottom: 6px;
}

.underline-field >>> .v-input__slot {
    border: none !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.23) !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: white !important;
    min-height: 40px !important;
    padding: 0 !important;
}

.underline-field >>> .v-input__slot:hover {
    border-bottom-color: rgba(0, 0, 0, 0.87) !important;
}

.underline-field.v-input--is-focused >>> .v-input__slot {
    border-bottom: 2px solid #1976d2 !important;
}

.underline-field >>> .v-text-field__slot input,
.underline-field >>> .v-select__slot input {
    padding: 8px 0 !important;
}

.underline-field >>> .v-text-field__slot input::placeholder,
.underline-field >>> .v-select__selection--placeholder {
    color: rgba(0, 0, 0, 0.38) !important;
    opacity: 1 !important;
}

.underline-field >>> .v-input__append-inner {
    margin-top: 4px !important;
}

.underline-field >>> .v-select__selections {
    padding: 8px 0 !important;
}

.underline-field >>> .v-messages {
    min-height: 14px;
    font-size: 12px;
}

::v-deep .v-radio {
    margin-right: 24px;
}

::v-deep .v-input--radio-group {
    margin-top: 0;
}
</style>